var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.272,
    height: 21.083,
    viewBox: "0 0 28.272 21.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#02ab77;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.6,85.767.414,76.579a1.414,1.414,0,0,1,0-2l2-2a1.414,1.414,0,0,1,2,0l6.19,6.19L23.86,65.512a1.414,1.414,0,0,1,2,0l2,2a1.414,1.414,0,0,1,0,2L11.6,85.767a1.414,1.414,0,0,1-2,0Z",
    transform: "translate(0 -65.098)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4a237c45.svg";
export { ForwardRef as ReactComponent };